var cell_default = {
  "cell": "OfOvk",
  "header": "HCqBI",
  "selected": "HqI7k",
  "editing": "YMduc",
  "singleSelection": "_5pz6C",
  "hideLastBlock": "Qg6-u",
  "editorWrapper": "-UWl-",
  "viewerWrapper": "tlsop",
  "hideFirstBlock": "pfggP",
  "editor": "r9VJh",
  "edit": "yZmHe",
  "view": "hWWi9",
  "editingToolbarWrapper": "IHdFQ",
  "selectAll": "CSJvB",
  "disableSelection": "RgnX-"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
